import { PERMISSION_CONSTANTS } from "@app/shared/auth/constants/permissions.constant";
import { IResourceChatDefinition } from "@app/shared/general/resource-chat/interfaces/resource-chat-definition.interfaces";
import { IVehicleBlock } from "../interfaces/vehicle-block.interface";

/**
 * Resource chat of vehicle blocks.
 *
 * Registered in `app.config.ts`; the view route and side panel refer to it by name.
 * Tokens, links, alerts and the chat UI are handled by the resource-chat module.
 */
export const VEHICLE_BLOCK_CHAT: IResourceChatDefinition<Pick<IVehicleBlock, "id" | "entityId" | "type">> = {
  resourceName: "vehicleBlock",
  typeLabel: "CHAT.RESOURCE_TYPES.VEHICLE_BLOCK",
  readPermission: PERMISSION_CONSTANTS.VEHICLE_BLOCK.CHAT_READ,
  recordQuery: "getVehicleBlock",
  accessQuery: "getVehicleBlockAccess",
  route: id => ["/movements-management/vehicle-blocks/view", id],
  labelFields: "entityId type { name }",
  label: block => `${block.entityId} · ${block.type.name}`,
};
